// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"2658039b","113":"64169235","121":"6b90f2e2","245":"adde7385","588":"51485f16","608":"9bdf3cf4","706":"4de978fd","815":"ac76856e","993":"a12156cc"}[chunkId] + ".chunk.js";
};